export default (title) => {
    const splitEditionTitle = title.split('-')
    const testEpaperStringIndex = splitEditionTitle.indexOf('EPaper')
    if (testEpaperStringIndex !== -1) splitEditionTitle.splice(testEpaperStringIndex, 1)
    return splitEditionTitle.length == 1 ? splitEditionTitle[0] : splitEditionTitle.join('-')
}